module.exports = __webpack_public_path__ + "static/img/qrCode_finance.917e38bc.jpg";